import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=6d4f7c10&scoped=true"
import script from "./orderPay.vue?vue&type=script&lang=js"
export * from "./orderPay.vue?vue&type=script&lang=js"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=6d4f7c10&prod&lang=scss"
import style1 from "./orderPay.vue?vue&type=style&index=1&id=6d4f7c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f7c10",
  null
  
)

export default component.exports